import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { CustomerModel } from "@models/configuration/customer.model";
import { Store } from "@ngrx/store";
import * as fromAppRoot from "@reducers/index";
import { CustomerActions } from "@actions/configuration/index";
import { TableStorageActionModel } from "@models/common/table-storage-action.model";
import { Partitions } from "@root/core/enums/partition.enum";
import { FacadeInterface } from "@interfaces/facade-interface";
import { AuthService } from "@services/auth/auth.service";
import { OracleStorageService } from "@services/oracle-storage.service";
import { OracleStorageActionModel } from "@models/common/oracle-storage-action.model";
import { map, tap } from "rxjs/operators";
import { environment } from "@environments/environment";

@Injectable({
  providedIn: "root",
})
export class CustomerFacadeService implements FacadeInterface<CustomerModel> {
  getAll$(): Observable<CustomerModel[]> {
    return this.store.select(fromAppRoot.getCustomers);
  }

  getAllAuthorization$(): Observable<CustomerModel[]> {
    return this.store.select(fromAppRoot.getCustomersAuthorization);
  }

  getCurrentItem$(): Observable<CustomerModel> {
    return this.store.select(fromAppRoot.getCurrentCustomer);
  }

  searchCustomersAuthorization(): void {
    const props: TableStorageActionModel<CustomerModel> = {
      queryParams: `${Partitions.CUSTOMER}/GetAll`,
    };
    this.store.dispatch(
      CustomerActions.searchCustomersAuthorization({ action: props })
    );
  }

  search(): void {
    const props: TableStorageActionModel<CustomerModel> = {
      queryParams: `${Partitions.CUSTOMER}/GetAll`,
    };
    this.store.dispatch(CustomerActions.searchCustomers({ action: props }));
  }

  create(payload: CustomerModel): void {
    const props: TableStorageActionModel<CustomerModel> = {
      queryParams: `${Partitions.CUSTOMER}/Post`,
      payload,
    };
    this.store.dispatch(CustomerActions.createCustomer({ action: props }));
  }

  update(payload: CustomerModel): void {
    const action: TableStorageActionModel<CustomerModel> = {
      queryParams: `${Partitions.CUSTOMER}/Post`,
      payload,
    };
    this.store.dispatch(CustomerActions.updateCustomer({ action }));
  }

  select(Customer: CustomerModel): void {
    this.store.dispatch(CustomerActions.selectCustomer({ Customer }));
  }

  delete(payload: CustomerModel): void {
    const props: TableStorageActionModel<CustomerModel> = {
      queryParams: `${Partitions.CUSTOMER}/Delete?id=` + payload.id,
      payload,
    };
    this.store.dispatch(CustomerActions.deleteCustomer({ action: props }));
  }

  cleanGetOne(): void {
    this.store.dispatch(CustomerActions.cleanCustomers(null));
  }

  reset(): void {}

  resetSelected(): void {}

  public getAllowsByMenu(): Observable<CustomerModel[]> {
    let currentUser = JSON.parse(localStorage.getItem("CurrentUser"));
    let access = localStorage.getItem("access");
    //console.log("CARGA APP MODULE", access);

    const action: OracleStorageActionModel<CustomerModel[]> = {
      queryParams: `${Partitions.CUSTOMER}/GetAll`,
    };
    //console.log("¿ESTA AUTENTICADO?",this._auth.isAuthenticate());
    if (this._auth.isAuthenticate() && (access==environment.ROLE_CONFIGURATION || access==environment.ROLE_NAME_ADMINISTRATION)) {
      let requestACL$: Observable<CustomerModel[]>;

      requestACL$ = this.oracleStorageService.createGeneric$(action);

      return requestACL$.pipe(
        //tap((customers: CustomerModel[]) => console.log(customers)),
        map((customers: CustomerModel[]) => {
          return customers.filter(
            (element) => element.email == currentUser.email && element.nameArea==access
          );
        }),
        //tap((customers: CustomerModel[]) => console.log(customers))
      );
    }
  }

  getIsLoading$(): Observable<boolean> {
    return this.store.select(fromAppRoot.getLoadingCustomer);
  }

  constructor(
    private store: Store<fromAppRoot.State>,
    private _auth: AuthService,
    private oracleStorageService: OracleStorageService<CustomerModel>
  ) {}
}
